import React from 'react';

import mainLogoImg from "./img/main-logo-2.svg";
import instaImg from "./img/instagram-icon.svg";
import whatsappImg from "./img/whatsapp-icon.svg";
import iconSpectraImg from "./img/icon-spectra.svg";
import atuacaoImg from "./img/atuacao.svg";
import middleLogoImg from "./img/middle-logo.svg";

import "./style/main.css";

function App() {
  function toggleAtuacao(e: React.MouseEvent<HTMLButtonElement>) {
    const buttonId = e.currentTarget.dataset.id || "";
    const descriptionElement = document.getElementById(buttonId);

    if (descriptionElement) descriptionElement.classList.toggle("hidden");
    e.currentTarget.querySelector(".show-icon")?.classList.toggle("hidden");
    e.currentTarget.querySelector(".hide-icon")?.classList.toggle("hidden");
  }

  return (
    <React.Fragment>
      <div className="main-container">
        <div className="destaque-wrapper">
        </div>
        
        <img src={mainLogoImg} className='logo-img' />
        
        <div className="content-wrapper">
            <div className="card-wrapper">
              <div className="card">
                <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.43964 7.27951L13.203 1.16408C13.6482 0.440667 14.4368 0 15.2862 0C16.7853 0 17.9317 1.33627 17.7038 2.81799L17.2937 5.48338C16.8502 8.36657 19.0809 10.9668 21.998 10.9668H23.1618C27.4422 10.9668 30.2262 15.4713 28.3119 19.2999L26.3741 23.1754C24.9452 26.0334 22.0241 27.8387 18.8288 27.8387H13.9193C11.6452 27.8387 9.63377 26.7138 8.41107 24.9902C8.42754 24.8171 8.43596 24.6417 8.43596 24.4643V10.9668C8.43596 10.4083 8.35247 9.86932 8.1973 9.36166C8.49631 8.81241 8.89443 8.16548 9.43964 7.27951Z" fill="#042122"/>
                  <path d="M5.90517 24.4643C5.90517 26.095 4.58325 27.4169 2.95259 27.4169C1.32192 27.4169 0 26.095 0 24.4643V10.9668C0 9.33608 1.32192 8.01416 2.95259 8.01416C4.58325 8.01416 5.90517 9.33608 5.90517 10.9668V24.4643Z" fill="#042122"/>
                </svg>

                <b>Eficiência</b>
                <span>Soluções jurídicas ágeis e estratégicas.</span>
              </div>

              <div className="card">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">
                  <path d="M10.5854 0C7.00225 0 4.09756 2.90469 4.09756 6.4878C4.09756 10.0709 7.00225 12.9756 10.5854 12.9756C14.1685 12.9756 17.0732 10.0709 17.0732 6.4878C17.0732 2.90469 14.1685 0 10.5854 0Z" fill="#042122"/>
                  <path d="M6.4878 15.0244C2.90469 15.0244 0 17.9291 0 21.5122C0 25.0953 2.90469 28 6.4878 28H14.6829C18.266 28 21.1707 25.0953 21.1707 21.5122C21.1707 17.9291 18.266 15.0244 14.6829 15.0244H6.4878Z" fill="#042122"/>
                </svg>

                <b>Ética</b>
                <span>Atuação pautada na integridade e no respeito.</span>
              </div>

              <div className="card">
                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5902 3.59097C26.3071 4.99782 26.3071 6.83949 26.3071 10.5228V12.0805C26.3071 14.3023 26.3071 15.4132 26.0413 16.3194C25.4111 18.4688 23.7302 20.1497 21.5808 20.7799C20.6746 21.0456 19.5637 21.0456 17.3419 21.0456H16.62L16.5344 21.0458C15.1924 21.0544 13.8852 21.4733 12.7882 22.2463L12.7184 22.296L9.28439 24.7488C8.10717 25.5897 6.56023 24.3754 7.09751 23.0322C7.47811 22.0807 6.77737 21.0456 5.75258 21.0456H4.96106C2.22114 21.0456 0 18.8245 0 16.0846V10.5228C0 6.83949 0 4.99782 0.716824 3.59097C1.34736 2.35348 2.35348 1.34736 3.59097 0.716824C4.99782 0 6.83949 0 10.5228 0H15.7842C19.4676 0 21.3092 0 22.7161 0.716824C23.9536 1.34736 24.9597 2.35348 25.5902 3.59097ZM9.20747 10.5228C9.20747 11.2493 8.61856 11.8382 7.89212 11.8382C7.16567 11.8382 6.57676 11.2493 6.57676 10.5228C6.57676 9.79637 7.16567 9.20747 7.89212 9.20747C8.61856 9.20747 9.20747 9.79637 9.20747 10.5228ZM14.4689 10.5228C14.4689 11.2493 13.88 11.8382 13.1535 11.8382C12.4271 11.8382 11.8382 11.2493 11.8382 10.5228C11.8382 9.79637 12.4271 9.20747 13.1535 9.20747C13.88 9.20747 14.4689 9.79637 14.4689 10.5228ZM18.4149 11.8382C19.1414 11.8382 19.7303 11.2493 19.7303 10.5228C19.7303 9.79637 19.1414 9.20747 18.4149 9.20747C17.6885 9.20747 17.0996 9.79637 17.0996 10.5228C17.0996 11.2493 17.6885 11.8382 18.4149 11.8382Z" fill="#042122"/>
                </svg>

                <b>Transparência</b>
                <span>Comunicação clara em todas as etapas do processo.</span>
              </div>
            </div>
          <div className="main-content">
            <span className='main-description'>Atuamos com excelência nas áreas de direito previdenciário, trabalhista, cível e criminal oferecendo nossos serviços em todo o Brasil.</span>
          </div>

          <b className="sub-title">Contatos:</b>
          <div className="contact-wrapper">
            <a href="https://www.instagram.com/jessicarlasf/" className='button'>
              <img src={instaImg} alt="" />
              <div className="text-wrapper">
                <b>@jessicarlasf</b>
                <span>Clique aqui e veja conteúdos diários</span>
              </div>
            </a>

            <a href="https://wa.me/5582996057762" className='button'>
              <img src={whatsappImg} alt="" />
              <div className="text-wrapper">
                <b>WhatsApp</b>
                <span>Atendimento ALAGOAS</span>
              </div>
            </a>

            <a href="https://wa.me/5582996057762" className='button'>
              <img src={whatsappImg} alt="" />
              <div className="text-wrapper">
                <b>WhatsApp</b>
                <span>Atendimento PERNAMBUCO</span>
              </div>
            </a>
          </div>

          <b className="sub-title">Área de atuação:</b>
          <div className="atuacao-wrapper">
            <img src={atuacaoImg} alt="" />

            <div className="separator">
              <div className="atuacao-item">
                <button data-id="auxilio-doenca" onClick={toggleAtuacao}>
                  <b>Prorrogação do auxílio doença</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="auxilio-doenca">
                  É possível prorrogar o auxílio doença desde que solicitado 15 dias antes da data de cessação de benefício.
                </span>
              </div>

              <div className="atuacao-item">
                <button data-id="invalidez" onClick={toggleAtuacao}>
                  <b>Aposentadoria por invalidez + 25%</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="invalidez">
                  O Aposentado por invalidez tem direito a 25% a mais se comprovar que precisa da ajuda de terceiros para realizar tarefas básicas do dia a dia.
                </span>
              </div>

              <div className="atuacao-item">
                <button data-id="mei-aposenta" onClick={toggleAtuacao}>
                  <b>Aposentadoria do MEI</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="mei-aposenta">
                  Em regra, o valor da aposentadoria para o MEI será de 01 (um) salário mínimo nacional. Dessa forma, para aposentados por essa modalidade, em 2024, o valor do benefício será de R$ 1.420,00.
                </span>
              </div>

              <div className="atuacao-item">
                <button data-id="doneca" onClick={toggleAtuacao}>
                  <b>Auxílio doença</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="doneca">
                  Benefício devido ao segurado(a) que comprovar incapacidade temporária para o trabalho. Tem carência de 12 meses.
                </span>
              </div>
            </div>
            
            <div className="separator">
              <div className="atuacao-item">
                <button data-id="loas-idoso" onClick={toggleAtuacao}>
                  <b>BPC Loas idoso</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="loas-idoso">
                  Idosos com 65 anos ou mais tem direito ao BPC/LOAS se for baixa renda, mesmo sem nunca ter contribuído para o INSS.
                </span>
              </div>

              <div className="atuacao-item">
                <button data-id="bpc-autista" onClick={toggleAtuacao}>
                  <b>BPC Autista</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="bpc-autista">
                  Crianças com Autismo podem ter direito a 1412,00 mensal se comprovar baixa renda.
                </span>
              </div>

              <div className="atuacao-item">
                <button data-id="maternidade" onClick={toggleAtuacao}>
                  <b>Salário maternidade</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="maternidade">
                  O salário maternidade é devido a segurada urbana ou rural pelo período de 120 dias.
                </span>
              </div>

              <div className="atuacao-item">
                <button data-id="rural" onClick={toggleAtuacao}>
                  <b>Aposentadoria rural</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="rural">
                  Benefício devido aos trabalhadores rurais que comprovarem o mínimo de 15 anos trabalhados na atividade rural, além da idade mínima de 60 anos, homem, ou 55 anos, mulher.
                </span>
              </div>

              <div className="atuacao-item">
                <button data-id="morte" onClick={toggleAtuacao}>
                  <b>Pensão por morte</b>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
                </button>

                <span className="hidden" id="morte">
                  A Pensão por Morte é devida aos dependentes daquele que: <br />É segurado do INSS; <br />Está em qualidade de segurado (o chamado “período de graça”); <br />Estiver recebendo benefício ou possuir direito adquirido a benefício.
                </span>
              </div>
            </div>
          </div>

          <div className="forte-atuacao">
            <img src={middleLogoImg} alt="" />

            <div className="atuacao-text-wrapper">
              <b className="sub-title">Também possuímos forte atuação em:</b>
              <div className="atuacao-wrapper">
                <div className="atuacao-item">
                  <button className='center'>
                    <b>Direito Trabalhista</b>
                  </button>
                </div>
                <div className="atuacao-item">
                  <button className='center'>
                    <b>Direito Cível</b>
                  </button>
                </div>
                <div className="atuacao-item">
                  <button className='center'>
                    <b>Direito Criminal</b>
                  </button>
                </div>
              </div>

              <b className="sub-title">Me chame no WhatsApp, será um prazer atendê-lo(a)!</b>
              <div className="contact-wrapper">
                <a href="https://wa.me/5582996057762" className='button'>
                  <img src={whatsappImg} alt="" />
                  <div className="text-wrapper">
                    <b>WhatsApp</b>
                    <span>Atendimento ALAGOAS</span>
                  </div>
                </a>

                <a href="https://wa.me/5582996057762" className='button'>
                  <img src={whatsappImg} alt="" />
                  <div className="text-wrapper">
                    <b>WhatsApp</b>
                    <span>Atendimento PERNAMBUCO</span>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <b className="sub-title">Dúvidas Frequentes:</b>
          <div className="faq-wrapper">
            <div className="faq-item">
              <button data-id="faq-1" onClick={toggleAtuacao}>
                  <b>Como funciona a primeira consulta?</b>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
              </button>

              <span className="hidden" id="faq-1">
                Oferecemos uma análise inicial gratuita do seu caso via WhatsApp ou presencial. Durante esta consulta, avaliamos a viabilidade da ação, explicamos seus direitos e apresentamos nossa estratégia jurídica. Você só pagará honorários após decidir contratar nossos serviços.
              </span>
            </div>

            <div className="faq-item">
              <button data-id="faq-2" onClick={toggleAtuacao}>
                  <b>Vocês atendem fora de AL e PE?</b>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
              </button>

              <span className="hidden" id="faq-2">
                Sim! De forma online, em todo o Brasil. Com a digitalização dos processos judiciais, que hoje tramitam 100% de maneira eletrônica, ampliamos ainda mais a viabilidade do atendimento remoto em nosso escritório. Nosso diferencial é o atendimento humanizado: mantemos nossos clientes sempre informados sobre cada etapa do processo, transmitindo tranquilidade e a confiança de que estamos realizando um trabalho sério, dedicado e de excelência.
              </span>
            </div>

            <div className="faq-item">
              <button data-id="faq-3" onClick={toggleAtuacao}>
                  <b>Como é o acompanhamento do meu processo</b>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='show-icon'>
                    <path d="M5.5925 4.1925L1.6925 0.2925C1.3025 -0.0975004 0.682499 -0.0975005 0.292499 0.2925C-0.0975018 0.6825 -0.0975018 1.3025 0.292499 1.6925L4.8925 6.2825C5.2825 6.6725 5.9125 6.6725 6.3025 6.2825L10.8925 1.6925C11.2825 1.3025 11.2825 0.6825 10.8925 0.2925C10.5025 -0.0975 9.8825 -0.0975001 9.4925 0.2925L5.5925 4.1925Z" fill="#042122"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" className='hide-icon hidden'>
                    <path d="M5.5925 2.38245L9.4925 6.28245C9.8825 6.67245 10.5025 6.67245 10.8925 6.28245C11.2825 5.89245 11.2825 5.27245 10.8925 4.88245L6.2925 0.29245C5.9025 -0.0975503 5.2725 -0.0975503 4.8825 0.29245L0.2925 4.88245C-0.0975 5.27245 -0.0975 5.89245 0.2925 6.28245C0.6825 6.67245 1.3025 6.67245 1.6925 6.28245L5.5925 2.38245Z" fill="#042122"/>
                  </svg>
              </button>

              <span className="hidden" id="faq-3">
                Mantemos nossos clientes sempre informados através de WhatsApp, e-mail e telefone. Você receberá atualizações regulares sobre o andamento do seu processo, cópias de documentos importantes e orientações sobre cada etapa. Nossa comunicação é transparente e acessível.
              </span>
            </div>
          </div>

          <div className="footer-container">
            <span className="spectra">
              Desenvolvido por
              <a href="https://spectra.tec.br" className='footer-img' target="_blank">
                <img src={iconSpectraImg}/>
              </a>
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default App;
